module.exports = __webpack_public_path__ + "img/bracket-square-right.8a1f7056.svg";